import Common from "../../../Common";
import Available from "./profile/Available";

interface CreateBody {
	teams_presence_id: id
	pbx_profile_id: id
}

const Profile = class extends Common {
	available: InstanceType<typeof Available>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.available = new Available(headers);
	}

	browse = () => this.get('/teams/presence/profile')
	delete = (teamsPresenceId: id) => this.doDelete(`/teams/presence/profile/${teamsPresenceId}`)

	/** Also used for updating */
	create(body: CreateBody) {
		return this.post('/teams/presence/profile', body)
	}
}

export default Profile;
